import type { ClassificationField, Distance } from "@bmi/elasticsearch-types";

export function convertToCentimeters(input: Distance): number;
export function convertToCentimeters(
  input?: ClassificationField,
  throwOnTypeError?: boolean
): number | undefined;
export function convertToCentimeters(
  input?: ClassificationField | Distance,
  throwOnTypeError = true
) {
  if (!input) {
    return;
  }

  const valueAsNumber = Number(input.value);
  if (isNaN(valueAsNumber)) {
    if (throwOnTypeError) {
      throw new Error("Value is not a number");
    }

    return;
  }

  //cm, mm, m, μm
  const unitOfLength =
    "unit" in input
      ? input.unit
      : input.code.slice(input.value.length).toLowerCase().trim();
  switch (unitOfLength) {
    case "mm":
      return valueAsNumber / 10;
    case "m":
      return valueAsNumber * 100;
    case "μm":
      return valueAsNumber / 10000;
    default:
      return valueAsNumber;
  }
}
